const getters = {
  userId: state => state.user.userId,
  token: state => state.user.token,
  avatar: state => state.user.info.picimg,
  name: state => state.user.name,
  postGroup: state => state.user.postGroup,
  roleGroup: state => state.user.roleGroup,
  info: state => state.user.info,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  isProfession: state => state.user.isProfession,
  isMechanism: state => state.user.isMechanism,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js